// Single source of truth for the UI locales. nuxt.config.ts builds the
// @nuxtjs/i18n `locales` list from this, and the SEO helpers (localized public
// routes, hreflang, sitemap) read the codes from here, so the two never drift.
export interface AppLocale {
  code: string;
  // BCP 47 tag used for <html lang>, og:locale and hreflang.
  language: string;
}

export const DEFAULT_LOCALE = "en";

export const LOCALES: AppLocale[] = [
  { code: "en", language: "en-US" },
  { code: "es", language: "es-ES" },
  { code: "zh", language: "zh-CN" },
  { code: "hi", language: "hi-IN" },
  { code: "ar", language: "ar-SA" },
  { code: "fr", language: "fr-FR" },
  { code: "pt", language: "pt-PT" },
  { code: "ja", language: "ja-JP" },
  { code: "de", language: "de-DE" },
  { code: "vi", language: "vi-VN" },
  { code: "ko", language: "ko-KR" },
  { code: "ru", language: "ru-RU" },
  { code: "it", language: "it-IT" },
  { code: "tr", language: "tr-TR" },
  { code: "id", language: "id-ID" },
  { code: "th", language: "th-TH" },
  { code: "bn", language: "bn-BD" },
  { code: "pl", language: "pl-PL" },
  { code: "nl", language: "nl-NL" },
  { code: "uk", language: "uk-UA" },
  { code: "ur", language: "ur-PK" },
  { code: "my", language: "my-MM" },
  { code: "fa", language: "fa-IR" },
  { code: "he", language: "he-IL" },
  { code: "ms", language: "ms-MY" },
  { code: "fil", language: "fil-PH" },
  { code: "ta", language: "ta-IN" },
  { code: "sw", language: "sw-KE" },
  { code: "ro", language: "ro-RO" },
  { code: "el", language: "el-GR" },
  { code: "cs", language: "cs-CZ" },
  { code: "hu", language: "hu-HU" },
  { code: "sv", language: "sv-SE" },
  { code: "fi", language: "fi-FI" },
  { code: "km", language: "km-KH" },
  { code: "ne", language: "ne-NP" },
];

export const LOCALE_CODES = LOCALES.map((l) => l.code);
